import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './hooks/useAuth';
import ProtectedRoute from './components/ProtectedRoute';
import LandingPage from './pages/LandingPage';
import Dashboard from './pages/Dashboard';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import AuthCallback from './components/auth/AuthCallback';
import GalleryPage from './pages/GalleryPage';
import ManageGalleryPage from './pages/ManageGalleryPage';
import NewGalleryPage from './pages/NewGalleryPage';
import VerifyEmailPage from './pages/VerifyEmailPage';
import FAQPage from './pages/FAQPage';
import ContactPage from './pages/ContactPage';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route path="/verify-email" element={<VerifyEmailPage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/new-gallery" element={<ProtectedRoute><NewGalleryPage /></ProtectedRoute>} />
          <Route path="/manage/:galleryId" element={<ProtectedRoute><ManageGalleryPage /></ProtectedRoute>} />
          <Route path="/gallery/:galleryName" element={<GalleryPage />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
